import { renderToString } from 'react-dom/server'
import { format, parseISO } from "date-fns"

const columns = [
  {
    data: 'name',
    className: 'bold',
    width: '60%',
    render: function (data, type, row, meta) {
      const date = row['last_started_at'] && row['state'] !== 'draft' ? format(parseISO(row['last_started_at'].replace(' ', 'T').replace(' UTC', 'Z')), "do MMMM yyyy, HH:mm") : ''
      const isDiscarded = row['discarded'] === 'true'
      const name = isDiscarded ? data : <a href={row['url']}>{data}</a>
      return renderToString(<div>
        {name}<br />
        {row['last_started_at'] && row['state'] !== 'draft' && <><span className='small-text'>Last started at: {date}</span><br /></>}
        {isDiscarded && <button className="button secondary small margin-top half restore-workflow" data-workflow-id={row.DT_RowId}>Restore automation</button>}
      </div>)
    },
  },
  {
    data: 'state',
    width: '20%',
    render: function (data, type, row, meta) {
      function getClass() {
        const status = row['state']
        if (status === 'running') return 'accent'
        if (status === 'paused') return 'red'

        return 'purple-60'
      }
      return `<span class="bold ${getClass()} capitalize">${row['state']}</span>`
    },
  },
  {
    data: 'completed',
    width: '20%',
    orderable: false,
    render: function (data, type, row, meta) {
      return `<span class="dark-grey">${row['completed']}</span>`
    },
  },
  { data: 'created_at', visible: false },
]

const headers = [
  'Name',
  'Status',
  'Completed'
]

const filters = [
]

const sorters = [
  { column: 3, label: 'Created', order: 'desc' },
  { column: 0, label: 'Alphabetically (A-Z)', order: 'asc' },
  { column: 0, label: 'Alphabetically (Z-A)', order: 'desc' }
]

const order = [[ 3, "desc" ]]

export { columns, headers, filters, sorters, order }
